export default __webpack_public_path__ + "static/media/ind3.4e1b8aaf.jpg";